import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * エリア一覧
 *
 * 病院に関連するエリアデータの一覧を返す
 */
export class FetchArea implements APIRequest<Monitaro.FetchAreaResponse> {
  response: Monitaro.FetchAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query

  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/areas`
  }
}

/**
 * 病院に紐づくエリア一覧
 *
 * 指定された病院IDに関連するエリアデータの一覧を返す
 */
export class FetchHospitalArea implements APIRequest<Monitaro.FetchAreaResponse> {
  response: Monitaro.FetchAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query

  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/areas/hospital`
  }
}
